import { render, staticRenderFns } from "./LeavesShow.vue?vue&type=template&id=73823b6f&"
import script from "./LeavesShow.vue?vue&type=script&lang=js&"
export * from "./LeavesShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports